import { render, staticRenderFns } from "./myTeam.vue?vue&type=template&id=1ccaebc4&scoped=true&"
import script from "./myTeam.vue?vue&type=script&lang=js&"
export * from "./myTeam.vue?vue&type=script&lang=js&"
import style0 from "./myTeam.vue?vue&type=style&index=0&id=1ccaebc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccaebc4",
  null
  
)

export default component.exports